import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { MaterialModule } from '../material.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { RouterModule } from '@angular/router';
import { FileUploadModule } from 'ng2-file-upload';
import { ReactiveFormsModule } from '@angular/forms';

import { PillarModule } from '../pillar/pillar.module'
import { reducers } from './store/reducers';
import { SubmissionDashboardComponent } from './components/submission-dashboard.component';
import { submissionRoutes } from './routes.config';
import { JobWorkspaceComponent } from './components/job-workspace.component';
import { UploadDialogComponent } from './components/upload-dialog.component';
import { SubmittingEntityTileComponent } from './components/submitting-entity-tile.component';
import { DashboardTilesRegistry } from '../pillar/dashboard/services/DashboardTilesRegistry';

import { JobsService } from './services/JobsService';
import { JobsServiceEffects } from './services/JobsService.effects';
import { SubmittingEntityService } from './services/SubmittingEntityService';
import { SubmittingEntityServiceEffects } from './services/SubmittingEntityService.effects';

import { ModuleConfiguration } from './submission.module.config';
import { SubmittingEntityWorkspaceComponent } from './components/submitting-entity-workspace.component';
import { AddSubmittingEntityDialogComponent } from './components/add-submitting-entity-dialog.component';
import { CoreModule } from '../core/core.module';
import { ErrorTypeDirective } from './directives/error-type.directive';
import { ErrorTypeManagerService } from './services/ErrorTypeManagerService';
import { AddVocabularyMappingDialogComponent } from './components/add-vocabulary-mapping-dialog.component';
import { DeleteSubmissionConfirmationDialogComponent } from './components/delete-submission-confirmation-dialog.component';
import { JobExportSelectionCriteriaDialogComponent } from "./components/job-export-selection-criteria-dialog.component";
import { AdvancedFilterDialogComponent } from './components/advanced-filter-dialog.component';
import { AppConfigurationService } from '../core/services/AppConfigurationService';
import { DatabaseJobsFilterDialogComponent } from './components/database-jobs-filter-dialog.component';
import { PowerbiReportViewerComponent } from './components/powerbi-report-viewer/powerbi-report-viewer.component';
import { PowerBIServiceApi } from '../core/services/PowerBIService';

@NgModule({
  entryComponents: [UploadDialogComponent, SubmittingEntityTileComponent, AddSubmittingEntityDialogComponent, AddVocabularyMappingDialogComponent, DeleteSubmissionConfirmationDialogComponent, JobExportSelectionCriteriaDialogComponent, AdvancedFilterDialogComponent, DatabaseJobsFilterDialogComponent],
  declarations: [SubmissionDashboardComponent, JobWorkspaceComponent, UploadDialogComponent, SubmittingEntityTileComponent, SubmittingEntityWorkspaceComponent, AddSubmittingEntityDialogComponent, ErrorTypeDirective, AddVocabularyMappingDialogComponent, DeleteSubmissionConfirmationDialogComponent, JobExportSelectionCriteriaDialogComponent, AdvancedFilterDialogComponent, DatabaseJobsFilterDialogComponent, PowerbiReportViewerComponent],
  imports: [
    CommonModule,
    MaterialModule,
    FlexLayoutModule,
    StoreModule.forFeature(ModuleConfiguration.moduleName, reducers),
    EffectsModule.forFeature([JobsServiceEffects, SubmittingEntityServiceEffects]),
    RouterModule.forChild(submissionRoutes),
    ReactiveFormsModule,
    PillarModule,
    FileUploadModule,
    CoreModule
  ],
  exports: [],
  providers: [JobsService, SubmittingEntityService, ErrorTypeManagerService, PowerBIServiceApi]
})
export class SubmissionModule {
  constructor(private dashboardTilesRegistry: DashboardTilesRegistry,
    private errorTypeManager: ErrorTypeManagerService,
    private appConfigurationService: AppConfigurationService) {
    dashboardTilesRegistry.registerTile('administration',
      {
        position: {
          colSpan: 4,
          rowSpan: 1.5
        },
        priorityOrder: 1,
        tileComponent: SubmittingEntityTileComponent,
        permission: "SubmissionModule.SubmittingEntity:View",
        displayName: "Submitting Entities"
      });

    if (!appConfigurationService.configuration.isUsingVms) {
      this.errorTypeManager.registerDialog("Invalid Vocabulary Code", AddVocabularyMappingDialogComponent);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/submission/submission.module.ts